/**
 * QuizFoot League - Catalogue visuel des cadres d'avatar cosmétiques
 * Les identifiants, prix et paliers doivent rester synchronisés avec
 * server/src/controllers/framesController.js (FRAME_CATALOG).
 */

export const FRAME_CATALOG = {
  bleu_ocean: {
    label: 'Bleu Océan',
    price: 150,
    tier: 'basique',
    style: {
      border: '3px solid #0ea5e9',
      boxShadow: '0 0 10px rgba(14,165,233,0.6), 0 0 20px rgba(14,165,233,0.25)',
    },
  },
  rouge_feu: {
    label: 'Rouge Feu',
    price: 150,
    tier: 'basique',
    style: {
      border: '3px solid #ef4444',
      boxShadow: '0 0 10px rgba(239,68,68,0.6), 0 0 20px rgba(239,68,68,0.25)',
    },
  },
  ivoire: {
    label: 'Ivoire',
    price: 600,
    tier: 'rare',
    style: {
      border: '3px solid #fef3c7',
      boxShadow: '0 0 10px rgba(254,243,199,0.8), 0 0 22px rgba(217,180,90,0.4)',
    },
  },
  arc_en_ciel: {
    label: 'Arc-en-ciel',
    price: 600,
    tier: 'rare',
    style: {
      border: '3px solid transparent',
      backgroundImage:
        'linear-gradient(white, white), linear-gradient(90deg, #ef4444, #f59e0b, #22c55e, #3b82f6, #a855f7, #ef4444)',
      backgroundOrigin: 'border-box',
      backgroundClip: 'content-box, border-box',
      boxShadow: '0 0 12px rgba(168,85,247,0.4)',
      animation: 'frameRainbowSpin 4s linear infinite',
    },
  },
  legende_doree: {
    label: 'Légende Dorée',
    price: 2500,
    tier: 'prestige',
    style: {
      border: '3px solid #f0b429',
      boxShadow: '0 0 14px #f0b429, 0 0 28px rgba(240,180,41,0.6), 0 0 42px rgba(240,180,41,0.3)',
      animation: 'frameLegendPulse 1.8s ease-in-out infinite',
    },
  },
};

export const FRAME_KEYFRAMES = `
  @keyframes frameRainbowSpin {
    0%   { filter: hue-rotate(0deg); }
    100% { filter: hue-rotate(360deg); }
  }
  @keyframes frameLegendPulse {
    0%, 100% { box-shadow: 0 0 14px #f0b429, 0 0 28px rgba(240,180,41,0.6), 0 0 42px rgba(240,180,41,0.3); }
    50%       { box-shadow: 0 0 22px #f0b429, 0 0 40px rgba(240,180,41,0.85), 0 0 60px rgba(240,180,41,0.5); }
  }
`;

export const TIER_LABELS = {
  basique:  { label: 'Basique',  color: '#94a3b8' },
  rare:     { label: 'Rare',     color: '#3b82f6' },
  prestige: { label: 'Prestige', color: '#f0b429' },
};
